// Demo motion layer (demo observe(), onScroll(), menu overlay).
// .reveal fades and rises into view, .unveil wipes a card photo open from the bottom. Both are
// revealed once by an IntersectionObserver with the demo's rootMargin and its (i % 4) * 70ms stagger.
// The header gets .shrink after 60px of scroll. Without JS, html.js is never set, so nothing is hidden.
(()=>{
  const reduced=()=>!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  let io=null;
  const show=node=>node.classList.add('in');
  const observe=()=>{
    const nodes=[...document.querySelectorAll('.reveal, .unveil')];
    if(!('IntersectionObserver' in window)){nodes.forEach(show);return;}
    if(!io)io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){show(entry.target);io.unobserve(entry.target);}}),{rootMargin:'0px 0px -8% 0px'});
    nodes.forEach((node,index)=>{
      if(node.classList.contains('in')||node.dataset.motionBound)return;
      node.dataset.motionBound='1';
      node.style.transitionDelay=(index%4)*70+'ms';
      io.observe(node);
    });
  };
  const header=()=>document.querySelector('[data-site-header]');
  // html.header-shrunk mirrors .shrink so the sticky bars under the header follow its height (--header-h).
  const onScroll=()=>{const top=header();const shrunk=window.scrollY>60;if(top)top.classList.toggle('shrink',shrunk);document.documentElement.classList.toggle('header-shrunk',Boolean(top)&&shrunk);};

  // Demo menuHTML(): a full-screen sheet that fades in, closed by ×, Esc or any link.
  const menu=()=>{
    const toggle=document.querySelector('[data-menu-toggle]');
    const nav=document.querySelector('[data-nav]');
    if(!toggle||!nav)return;
    const close=nav.querySelector('[data-menu-close]');
    const setOpen=open=>{
      nav.classList.toggle('is-open',open);
      toggle.setAttribute('aria-expanded',String(open));
      document.documentElement.classList.toggle('menu-open',open);
      if(open&&close)close.focus();
    };
    // saintcha.js toggles .is-open on the button click; keep the page state in step with it.
    toggle.addEventListener('click',()=>window.setTimeout(()=>{const open=nav.classList.contains('is-open');document.documentElement.classList.toggle('menu-open',open);if(open&&close)close.focus();},0));
    close?.addEventListener('click',()=>{setOpen(false);toggle.focus();});
    nav.addEventListener('click',event=>{if(event.target.closest('a'))setOpen(false);});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&nav.classList.contains('is-open')){setOpen(false);toggle.focus();}});
    window.addEventListener('resize',()=>{if(window.innerWidth>900&&nav.classList.contains('is-open'))setOpen(false);});
  };

  // Demo .stickybuy on the product page: mirror the size, price a bowl, line total and button state.
  const stickyBuy=()=>{
    const bar=document.querySelector('[data-stickybuy]');
    if(!bar)return;
    const meta=bar.querySelector('[data-stickybuy-meta]'),price=bar.querySelector('[data-stickybuy-price]'),add=bar.querySelector('[data-stickybuy-add]');
    const mainPrice=document.querySelector('[data-product-price]'),mainAdd=document.querySelector('[data-add-button]'),perBowl=document.querySelector('[data-product-per-bowl]');
    const sync=()=>{
      const size=document.querySelector('[data-size-option].on span');
      if(meta&&size)meta.textContent=size.textContent.trim()+(perBowl&&perBowl.textContent.trim()?' · '+perBowl.textContent.trim():'');
      if(price&&mainPrice)price.textContent=mainPrice.textContent.trim();
      if(add&&mainAdd){add.disabled=mainAdd.disabled&&!mainAdd.classList.contains('is-loading');add.textContent=mainAdd.textContent.split(' · ')[0].trim()||add.textContent;}
    };
    const watch=[mainPrice,mainAdd,perBowl,document.querySelector('[data-size-options]')].filter(Boolean);
    if('MutationObserver' in window){const mo=new MutationObserver(sync);watch.forEach(node=>mo.observe(node,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['class','disabled']}));}
    sync();
  };

  const init=()=>{
    observe();onScroll();menu();stickyBuy();
    window.addEventListener('scroll',onScroll,{passive:true});
    // Theme editor: a re-rendered section brings new .reveal/.unveil nodes.
    document.addEventListener('shopify:section:load',observe);
  };
  window.SaintchaMotion={observe,reduced};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
